
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paginas/[page]",
      function () {
        return require("private-next-pages/paginas/[page]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paginas/[page]"])
      });
    }
  